import { useState } from 'react';
import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const VideosPage = () => {
  const [selectedVideo, setSelectedVideo] = useState<string | null>(null);

  const videos = [
    {
      id: 1,
      category: 'cranes',
      title: 'رافعة 300 طن في العمل',
      description: 'مشاهدة رافعة ثقيلة 300 طن وهي ترفع حمولات ضخمة',
      thumbnail: 'massive yellow hydraulic crane 300 ton capacity lifting heavy steel beams at construction site, dramatic action shot, professional video thumbnail style',
      duration: '3:45',
      views: '12.5K',
    },
    {
      id: 2,
      category: 'cranes',
      title: 'رافعة متوسطة 130 طن',
      description: 'عرض قدرات الرافعة المتوسطة في مشروع تجاري',
      thumbnail: 'medium yellow hydraulic crane 130 ton working at commercial building construction, professional video thumbnail, action photography',
      duration: '4:20',
      views: '8.3K',
    },
    {
      id: 3,
      category: 'cranes',
      title: 'رافعات خفيفة متعددة',
      description: 'مجموعة من الرافعات الخفيفة في مواقع مختلفة',
      thumbnail: 'multiple small mobile yellow cranes 7-19 ton working at various construction sites, professional video thumbnail compilation style',
      duration: '5:15',
      views: '15.2K',
    },
    {
      id: 4,
      category: 'equipment',
      title: 'معدات ثقيلة متنوعة',
      description: 'عرض شامل لجميع المعدات الثقيلة المتاحة',
      thumbnail: 'various heavy construction equipment including wheel loaders excavators boom trucks at work site in Saudi Arabia, professional video thumbnail',
      duration: '6:30',
      views: '20.1K',
    },
    {
      id: 5,
      category: 'equipment',
      title: 'شيول وحفارات',
      description: 'معدات الحفر والنقل في العمل',
      thumbnail: 'yellow wheel loaders and excavators heavy equipment moving earth and materials at construction site, action video thumbnail style',
      duration: '4:50',
      views: '11.7K',
    },
    {
      id: 6,
      category: 'equipment',
      title: 'معدات خفيفة - سيزر لفت',
      description: 'منصات الرفع العمودية في العمل',
      thumbnail: 'yellow scissor lift platforms light equipment working at indoor construction site in Saudi Arabia, professional video thumbnail',
      duration: '3:20',
      views: '7.9K',
    },
    {
      id: 7,
      category: 'projects',
      title: 'مشروع برج الرياض',
      description: 'فيديو كامل لمشروع برج ضخم في الرياض',
      thumbnail: 'massive skyscraper construction project in Riyadh with multiple yellow cranes working, time-lapse video thumbnail style, dramatic sunset',
      duration: '8:45',
      views: '35.6K',
    },
    {
      id: 8,
      category: 'projects',
      title: 'بناء جسر الطرق السريعة',
      description: 'مشروع بنية تحتية ضخم',
      thumbnail: 'highway bridge infrastructure construction with cranes and heavy equipment in Saudi Arabia, aerial video thumbnail, professional cinematography',
      duration: '7:10',
      views: '28.4K',
    },
    {
      id: 9,
      category: 'projects',
      title: 'مجمع تجاري كبير',
      description: 'من البداية حتى النهاية',
      thumbnail: 'large commercial complex construction time-lapse with yellow cranes, modern glass building progress video thumbnail, Saudi Arabia',
      duration: '10:20',
      views: '42.3K',
    },
    {
      id: 10,
      category: 'cranes',
      title: 'صيانة وفحص الرافعات',
      description: 'كيف نحافظ على رافعاتنا في أفضل حال',
      thumbnail: 'professional maintenance and inspection of yellow hydraulic cranes, technicians working on equipment, industrial video thumbnail',
      duration: '5:40',
      views: '9.8K',
    },
    {
      id: 11,
      category: 'equipment',
      title: 'فورك لفت ومان لفت',
      description: 'معدات الرفع الخفيفة في المستودعات',
      thumbnail: 'yellow forklift and man lift light equipment working in warehouse and construction site, professional video thumbnail style',
      duration: '4:05',
      views: '6.5K',
    },
    {
      id: 12,
      category: 'projects',
      title: 'مصنع صناعي ضخم',
      description: 'بناء منشأة صناعية كاملة',
      thumbnail: 'massive industrial factory construction with heavy cranes installing steel structures, industrial zone Saudi Arabia, video thumbnail',
      duration: '9:15',
      views: '31.2K',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center overflow-hidden mt-20">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/2453e1d775c2e2fb6b6467d44e6983bf.jpg"
            alt="معرض الفيديوهات"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-primary/75"></div>
        </div>

        <div className="relative z-10 container mx-auto px-6 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="w-24 h-24 flex items-center justify-center bg-accent rounded-full mx-auto mb-6">
              <i className="ri-video-fill text-5xl text-primary"></i>
            </div>
            <h1 className="text-6xl md:text-7xl font-black text-white mb-6">معرض الفيديوهات</h1>
            <p className="text-2xl text-accent font-bold">شاهد رافعاتنا ومعداتنا في العمل الفعلي</p>
          </motion.div>
        </div>
      </section>

      {/* Videos Grid */}
      <section className="py-24 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {videos.map((video, index) => (
              <motion.div
                key={video.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.05 }}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all group cursor-pointer"
                onClick={() => setSelectedVideo(video.id.toString())}
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={`https://readdy.ai/api/search-image?query=$%7Bvideo.thumbnail%7D&width=600&height=400&seq=video-thumb-${video.id}&orientation=landscape`}
                    alt={video.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-primary/90 via-primary/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  
                  {/* Play Button */}
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-20 h-20 flex items-center justify-center bg-accent rounded-full group-hover:scale-110 transition-transform duration-300 shadow-2xl">
                      <i className="ri-play-fill text-4xl text-primary mr-[-4px]"></i>
                    </div>
                  </div>

                  {/* Duration Badge */}
                  <div className="absolute bottom-4 right-4 bg-primary/90 text-white px-3 py-1 rounded-lg text-sm font-bold">
                    {video.duration}
                  </div>
                </div>

                <div className="p-6">
                  <h3 className="text-xl font-black text-primary mb-2">{video.title}</h3>
                  <p className="text-gray-600 text-sm mb-4">{video.description}</p>
                  
                  <div className="flex items-center justify-between text-sm text-gray-500">
                    <div className="flex items-center gap-2">
                      <i className="ri-eye-line"></i>
                      <span>{video.views} مشاهدة</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <i className="ri-time-line"></i>
                      <span>{video.duration}</span>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Video Modal */}
      {selectedVideo && (
        <div 
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-6"
          onClick={() => setSelectedVideo(null)}
        >
          <button
            className="absolute top-6 right-6 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-all z-10"
            onClick={() => setSelectedVideo(null)}
          >
            <i className="ri-close-line text-3xl text-white"></i>
          </button>
          
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
            className="w-full max-w-5xl bg-white rounded-2xl overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative aspect-video bg-gray-900">
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-center text-white">
                  <i className="ri-video-line text-6xl mb-4 opacity-50"></i>
                  <p className="text-xl opacity-75">مشغل الفيديو</p>
                  <p className="text-sm opacity-50 mt-2">سيتم دمج مشغل الفيديو الفعلي هنا</p>
                </div>
              </div>
            </div>
            
            <div className="p-6">
              <h3 className="text-2xl font-black text-primary mb-2">
                {videos.find(v => v.id.toString() === selectedVideo)?.title}
              </h3>
              <p className="text-gray-600">
                {videos.find(v => v.id.toString() === selectedVideo)?.description}
              </p>
            </div>
          </motion.div>
        </div>
      )}

      {/* CTA Section */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-5xl md:text-6xl font-black text-primary mb-6">
              هل أعجبتك فيديوهاتنا؟
            </h2>
            <p className="text-2xl text-gray-600 mb-12 max-w-3xl mx-auto">
              تواصل معنا الآن للحصول على خدماتنا المتميزة
            </p>
            <div className="flex flex-wrap justify-center gap-6">
              <a
                href="/gallery"
                className="bg-accent hover:bg-accent-dark text-primary px-12 py-5 rounded-xl font-black text-xl transition-all shadow-2xl hover:shadow-accent/50 hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-3"
              >
                <i className="ri-image-fill text-2xl"></i>
                <span>شاهد معرض الصور</span>
              </a>
              <a
                href="/contact"
                className="bg-primary hover:bg-primary-dark text-white px-12 py-5 rounded-xl font-bold text-xl transition-all shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center gap-3"
              >
                <i className="ri-phone-fill text-2xl"></i>
                <span>تواصل معنا</span>
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default VideosPage;